import { render, staticRenderFns } from "./MasterDataGovernanceOverview.vue?vue&type=template&id=159d7620&scoped=true"
import script from "./MasterDataGovernanceOverview.vue?vue&type=script&lang=js"
export * from "./MasterDataGovernanceOverview.vue?vue&type=script&lang=js"
import style0 from "./MasterDataGovernanceOverview.vue?vue&type=style&index=0&id=159d7620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d7620",
  null
  
)

export default component.exports